import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "on-focus__popular-queries-container q-text-dark"
}
const _hoisted_2 = { class: "on-focus__popular-queries-content q-row" }

import QueriesContainer from '../Queries/QueriesContainer.vue'

import {onMounted, inject} from "vue";
import {storeToRefs} from "pinia";
import {usePopularQueriesStore} from "@/store/AutocompletePopup/PopularQueriesStore";
import {SmartSearchTranslationsInterface} from "@/core/types";



export default /*@__PURE__*/_defineComponent({
  __name: 'PopularQueriesContainer',
  setup(__props) {

const popularQueriesStore = usePopularQueriesStore()
const {getPopularQueries, hasPopularQueries} = storeToRefs(popularQueriesStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
onMounted(async () => {
  await popularQueriesStore.fetchPopularQueries()
})


return (_ctx: any,_cache: any) => {
  return (_unref(hasPopularQueries))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(QueriesContainer, {
            queries: _unref(getPopularQueries),
            "queries-header": _unref(SmartSearchTranslations).popularQueries.header
          }, null, 8, ["queries", "queries-header"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})